import { useQuery } from "react-query";
import SecureRequestFetch from "../utils/securerequestfetch";

export const useCustomerDetails = (clientId) => {
  return useQuery(
    ["customer", clientId],
    async () => {
      if (!clientId) return null;

      const sr = new SecureRequestFetch();
      const response = await sr.get(`/customers/${clientId}`);
      return response.data?.customer || response.data;
    },
    {
      enabled: !!clientId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: false,
      onError: (error) => {
        console.warn("Failed to fetch customer details:", error);
      }
    }
  );
};
